import React, {useState} from 'react';
import type {TableColumnsType} from 'antd';
import {Table} from 'antd';
import { VoucherClearingType } from '../graphql/types/VoucherClearingType';

interface SettlementVoucherRowProps {
    rowData: VoucherClearingType[];
    loading?: boolean;
}

export const VoucherClearingColumns: React.FC<SettlementVoucherRowProps> = ({
    rowData, 
    loading
}) => {

    const voucherClearingColumns: TableColumnsType<VoucherClearingType> = [
        {
            title: 'Tracking',
            dataIndex: 'businessId',
            key: 'businessId',
            align: 'left',
        },
        {
            title: 'Order',
            dataIndex: 'otherBusinessId',
            key: 'otherBusinessId',
            align: 'left',
        },
        {
            title: 'Client',
            dataIndex: 'settlementClientName',
            key: 'settlementClientName',
            align: 'left',
        },
        {
            title: 'Settlement Code Name',
            dataIndex: 'settlementItemName',
            key: 'settlementItemName',
            align: 'left',
            render: (settlementItemName) => {
                return <span className={`inline-block px-2 py-1 rounded `}>{settlementItemName}</span>;
            },
        },
        {
            title: 'Amount',
            key: 'amount',
            align: 'left',
            render: (_,record) => {
                return record.amount? `$${record.amount}` : '$0.00';
            },
        },
        {
            title: 'Amount(HM)',
            key: 'amountHm',
            align: 'left',
            render: (_,record) => {
                return record.amountHm ? `$${record.amountHm}` : '$0.0000';
            },
        },
        {
            title: 'Voucher Status',
            key: 'status',
            align: 'left',
            render: (_,record) => {
                if(Number(record.status) == 1) return 'avaliable';
                return 'unavaliable'
            },
        },
        {
            title: 'Business Time',
            dataIndex: 'businessTime',
            key: 'businessTime',
            align: 'left',
        },
        {
            title: 'Settlement Time',
            dataIndex: 'settlementTime',
            key: 'settlementTime',
            align: 'left',
        },
        {
            title: 'Time Zone',
            dataIndex: 'timeZone',
            key: 'timeZone',
            align: 'left',
        }
    ];

    return (
        <Table
            rowKey={(record) => record.id}
            columns={voucherClearingColumns}
            dataSource={rowData}
            scroll={{x: 2250}}
            size="middle"
            className="mb-4"
            pagination={false}
            loading={loading}
        />
    );
};